import api, { API, fmtPKR } from "./api";

// Download PDF directly
export async function downloadInvoicePdf(saleId, invoiceNo) {
  const token = localStorage.getItem("afridi_token");
  const res = await fetch(`${API}/sales/${saleId}/pdf`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("PDF download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `invoice_${invoiceNo || saleId}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

// Open invoice PDF in a clean new window for printing (no app chrome / no URL header artifacts)
export async function openInvoicePrint(saleId) {
  const token = localStorage.getItem("afridi_token");
  const res = await fetch(`${API}/sales/${saleId}/pdf`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank", "noopener,noreferrer");
  if (w) {
    // Try to trigger print once loaded
    setTimeout(() => {
      try {
        w.focus();
        w.print();
      } catch (e) {
        // user can print manually
      }
    }, 800);
  }
}

// WhatsApp share — open wa.me with prefilled message
export function openWhatsAppShare(sale, settings, phone) {
  if (!sale || !settings) return;
  // Clean phone: keep digits only, prepend country code if local PK format
  const cleanPhone = (phone || "").replace(/\D/g, "");
  let waNumber = cleanPhone;
  if (cleanPhone.startsWith("0")) {
    waNumber = "92" + cleanPhone.substring(1); // PK country code
  } else if (cleanPhone.length === 10) {
    waNumber = "92" + cleanPhone;
  }

  const lines = [];
  lines.push(`*${settings.business_name}*`);
  lines.push(`${settings.tagline}`);
  lines.push("");
  lines.push(`*Invoice:* ${sale.invoice_no}`);
  lines.push(`*Date:* ${new Date(sale.date).toLocaleString("en-GB")}`);
  lines.push(`*Customer:* ${sale.customer_name}`);
  lines.push("");
  lines.push("*Items:*");
  (sale.items || []).forEach((it, i) => {
    lines.push(`${i + 1}. ${it.name} x ${it.quantity} @ ${fmtPKR(it.rate)} = ${fmtPKR(it.amount)}`);
  });
  lines.push("");
  lines.push(`*Subtotal:* ${fmtPKR(sale.subtotal)}`);
  if (sale.overall_discount) lines.push(`*Discount:* ${fmtPKR(sale.overall_discount)}`);
  lines.push(`*GRAND TOTAL:* ${fmtPKR(sale.grand_total)}`);
  lines.push(`*Payment:* ${(sale.payment_method || "").toUpperCase()}`);
  lines.push("");
  lines.push(`Phone: ${(settings.phones || []).join(", ")}`);
  lines.push(`${settings.address}`);
  lines.push("");
  lines.push("Thank you for your business!");

  const message = encodeURIComponent(lines.join("\n"));
  const url = waNumber
    ? `https://wa.me/${waNumber}?text=${message}`
    : `https://wa.me/?text=${message}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
